<div *ngIf="prop.demo && prop.details.accessSharing" class="demo">
  <div>
    <div>Ce bien est une démonstration vous permettant de découvrir les fonctionnalités d'EEMO</div>
    <button mat-flat-button (click)="confirmDeleteDemoProp()">Ne plus le voir</button>
  </div>
</div>

<div [class]="'wrap-rounded-link '+ (hasSubscriptionAlert ? 'subscription-alert' : '') ">
  <app-rounded-link *ngFor="let item of list" [id]="item.id" color="primary" [link]="item.link" [icon]="item.icon"
    squareMode="true" [type]="'SMALL'" [text]="item.subTitle ? item.subTitle : item.title" [disabled]="item.disabled"
    [kpi]="item.kpi" [showKpi]="item.id!=='PROP_SALE'"
    [appTooltip]="'MenuTooltips.'+item.id | translate"></app-rounded-link>
</div>

<div class="prop-summary">
  <app-property-summary [prop]="prop" [fullMode]="true"></app-property-summary>
</div>